const NWF_API_ENDPOINT = "https://nwf-generator.vercel.app/api/make-word";
const NWF_MUG_PRODUCT_URL = "/products/personalized-mug?variant=46818514075804%26nwf=preview%26nwf_cache=202605100100";
const NWF_OLD_MUG_NAME = /personalized mug/gi;
const NWF_NEW_MUG_NAME = "Nerd Word Mug";
const NWF_MOMENT_CHOICES = [
  "I love you",
  "Celebrate someone",
  "Encourage someone",
  "Remember someone",
  "Make someone laugh"
];
const NWF_PRODUCT_OPTIONS = [
  {
    kind: "greeting-card",
    title: "Greeting Card",
    subtitle: "5 x 7 greeting card",
    price: "$20.00",
    href: "/products/greeting-card?nwf=preview",
    variantId: 45554038374556,
    image: "https://cdn.shopify.com/s/files/1/0690/5970/7036/files/6a2ae48f3af26.webp?v=1781195922",
    imageAlt: "Greeting Card"
  },
  {
    kind: "framed-poster",
    title: "Framed Poster",
    subtitle: "Black framed poster, 18 x 24",
    price: "$100.00",
    href: "/products/enhanced-matte-paper-framed-poster?nwf=preview",
    variantId: 45554033721500,
    image: "https://cdn.shopify.com/s/files/1/0690/5970/7036/files/6924cac9d0ac3.webp?v=1776795563",
    imageAlt: "Framed Poster"
  }
];

function nwfProductPreviewMarkup(product) {
  const inputId = `wf-quantity-${product.kind}`;

  return `
    <article class="wf-product-preview wf-product-preview--${product.kind}" data-product-preview="${product.kind}" data-variant-id="${product.variantId}">
      <div class="wf-product-media" aria-label="${product.title} preview">
        <img class="wf-product-image" src="${product.image}" alt="${product.imageAlt}" width="2048" height="2048" loading="lazy">
        <div class="wf-live-art wf-live-art--${product.kind}">
          <p class="wf-preview-brand">Nerd Word Foundry</p>
          <div class="wf-preview-entry">
            <p class="wf-preview-label">New word</p>
            <p class="wf-preview-word" data-preview-word>-</p>
          </div>
          <div class="wf-preview-entry">
            <p class="wf-preview-label">Pronunciation key</p>
            <p class="wf-preview-pronunciation" data-preview-pronunciation>-</p>
          </div>
          <div class="wf-preview-entry">
            <p class="wf-preview-label">Definition</p>
            <p class="wf-preview-definition" data-preview-definition>-</p>
          </div>
          <div class="wf-preview-entry">
            <p class="wf-preview-label">Sample sentence</p>
            <p class="wf-preview-sample" data-preview-sample>-</p>
          </div>
        </div>
      </div>
      <div class="wf-product-details">
        <h4 class="wf-product-title">${product.title}</h4>
        <p class="wf-product-note">${product.subtitle}</p>
        <p class="wf-product-price">${product.price}</p>
        <label class="wf-quantity-label" for="${inputId}">Quantity</label>
        <div class="wf-quantity-control" data-quantity-control="${product.kind}">
          <button class="wf-quantity-step" type="button" data-quantity-step="-1" data-product-kind="${product.kind}" aria-label="Decrease ${product.title} quantity">-</button>
          <input id="${inputId}" class="wf-quantity-input" type="number" min="1" step="1" value="1" inputmode="numeric" data-product-quantity="${product.kind}">
          <button class="wf-quantity-step" type="button" data-quantity-step="1" data-product-kind="${product.kind}" aria-label="Increase ${product.title} quantity">+</button>
        </div>
      </div>
    </article>
  `;
}

function nwfProductShowcaseMarkup() {
  return `
    <div class="wf-product-showcase" data-product-showcase>
      <div class="wf-preview-list">
        ${NWF_PRODUCT_OPTIONS.map(product => nwfProductPreviewMarkup(product)).join("")}
      </div>
      <div class="wf-checkout-panel">
        <button class="wf-btn wf-btn-primary wf-checkout-button" type="button" data-action="checkout">
          CHECK OUT
        </button>
        <p class="wf-checkout-status" data-checkout-status aria-live="polite"></p>
      </div>
    </div>
  `;
}

function normalizeNwfProductName(root = document.body) {
  if (!root) return;

  const replaceMugName = value => String(value || "").replace(NWF_OLD_MUG_NAME, NWF_NEW_MUG_NAME);
  const hasOldMugName = value => /personalized mug/i.test(String(value || ""));

  if (document.title && hasOldMugName(document.title)) {
    document.title = replaceMugName(document.title);
  }

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parent = node.parentElement;
      if (!parent) return NodeFilter.FILTER_REJECT;
      if (["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA"].includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
      return hasOldMugName(node.nodeValue)
        ? NodeFilter.FILTER_ACCEPT
        : NodeFilter.FILTER_REJECT;
    }
  });

  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(node => {
    node.nodeValue = replaceMugName(node.nodeValue);
  });

  ["aria-label", "title", "alt"].forEach(attribute => {
    root.querySelectorAll?.(`[${attribute}*="Personalized Mug" i]`).forEach(element => {
      element.setAttribute(attribute, replaceMugName(element.getAttribute(attribute)));
    });
  });
}

function observeNwfProductName() {
  normalizeNwfProductName();

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          if (/personalized mug/i.test(node.nodeValue || "")) {
            node.nodeValue = node.nodeValue.replace(NWF_OLD_MUG_NAME, NWF_NEW_MUG_NAME);
          }
          return;
        }

        if (node.nodeType === Node.ELEMENT_NODE) normalizeNwfProductName(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

class WordFactory {
  constructor(root) {
    this.root = root;
    this.sectionId = root.id.replace("word-factory-", "");
    this.endpoint = root.dataset.apiEndpoint || NWF_API_ENDPOINT;
    this.authToken = root.dataset.apiToken || "";

    this.normalizeMarkup();

    this.elements = {
      who: this.findInput("who"),
      what: this.findInput("what", "moment"),
      vibe: this.findInput("vibe", "when"),
      statusText: root.querySelector(".wf-status-text"),
      resultWrap: root.querySelector(".wf-result"),
      word: root.querySelector("[data-word]"),
      pronunciation: root.querySelector("[data-pronunciation-key]"),
      description: root.querySelector("[data-description]") || root.querySelector("[data-definition]"),
      sampleSentence: root.querySelector("[data-sample-sentence]"),
      btnGenerate: root.querySelector('[data-action="generate"]'),
      btnCheckout: root.querySelector('[data-action="checkout"]'),
      checkoutStatus: root.querySelector("[data-checkout-status]"),
      btnPlaceWord: root.querySelector('[data-action="place-word"]'),
      btnReset: root.querySelector('[data-action="reset"]'),
      purchaseStep: root.querySelector("[data-nwf-purchase-step]"),
      mugSection: this.findMugSection()
    };

    if (!this.elements.btnGenerate) return;

    this.lastGenerated = null;
    this.elements.btnGenerate.addEventListener("click", () => this.generate());
    this.elements.btnCheckout?.addEventListener("click", () => this.checkout());
    this.elements.btnReset?.addEventListener("click", () => this.reset());
    this.elements.btnPlaceWord?.addEventListener("click", () => this.placeWord());
    this.bindMomentChoices();
    this.bindQuantityControls();
    this.hideMugPurchaseStep();
  }

  findInput(...names) {
    for (const name of names) {
      const byName = this.root.querySelector(`input[name="${name}"], textarea[name="${name}"]`);
      if (byName) return byName;

      const byId = document.getElementById(`wf-${name}-${this.sectionId}`);
      if (byId && this.root.contains(byId)) return byId;
    }

    return null;
  }

  normalizeMarkup() {
    this.root.dataset.apiEndpoint = this.endpoint;
    this.normalizeInputCopy();

    const intro = this.root.querySelector(".wf-intro");
    if (intro) intro.textContent = "Give the who, moment, and kind of moment.";

    const card = this.root.querySelector(".wf-card");
    if (!card) return;

    card.innerHTML = `
      <dl class="wf-output-list">
        <div class="wf-output-row">
          <dt>New Word</dt>
          <dd class="wf-word" data-word>-</dd>
        </div>
        <div class="wf-output-row">
          <dt>Pronunciation key</dt>
          <dd class="wf-pronunciation-key" data-pronunciation-key>-</dd>
        </div>
        <div class="wf-output-row">
          <dt>Definition</dt>
          <dd class="wf-description" data-description data-definition>-</dd>
        </div>
        <div class="wf-output-row">
          <dt>Sample sentence</dt>
          <dd class="wf-sample-sentence" data-sample-sentence>-</dd>
        </div>
      </dl>

      ${nwfProductShowcaseMarkup()}
    `;
  }

  normalizeInputCopy() {
    const who = this.findInput("who");
    const what = this.findInput("what", "moment");
    const vibe = this.findInput("vibe", "when");

    const setLabel = (input, text) => {
      if (!input?.id) return;
      const label = this.root.querySelector(`label[for="${input.id}"]`);
      if (label) label.textContent = text;
    };

    setLabel(who, "Who is this for?");
    setLabel(what, "What's the moment?");
    setLabel(vibe, "What kind of moment is this?");

    if (who) who.placeholder = "Maya and Roger";
    if (what) what.placeholder = "anniversary";
    if (vibe) {
      this.ensureMomentChoices(vibe);
      vibe.placeholder = "I love you";
      vibe.name = "vibe";
      vibe.setAttribute("aria-label", "What kind of moment is this?");
    }
  }

  ensureMomentChoices(input) {
    if (!input || this.root.querySelector("[data-moment-picks]")) return;

    const picker = document.createElement("div");
    picker.className = "wf-moment-picks";
    picker.dataset.momentPicks = "";
    picker.setAttribute("aria-label", "Moment ideas");
    picker.innerHTML = NWF_MOMENT_CHOICES.map(choice =>
      `<button class="wf-moment-pick" type="button" data-moment-choice="${choice}">${choice}</button>`
    ).join("");

    input.insertAdjacentElement("beforebegin", picker);
  }

  bindMomentChoices() {
    this.root.querySelectorAll("[data-moment-choice]").forEach(button => {
      button.addEventListener("click", () => {
        const choice = button.dataset.momentChoice || button.textContent || "";
        if (!this.elements.vibe) return;

        this.elements.vibe.value = choice.trim();
        this.elements.vibe.dispatchEvent(new Event("input", { bubbles: true }));
        this.elements.vibe.dispatchEvent(new Event("change", { bubbles: true }));
        this.root.querySelectorAll("[data-moment-choice]").forEach(item => {
          item.classList.toggle("wf-moment-pick--selected", item === button);
          item.setAttribute("aria-pressed", item === button ? "true" : "false");
        });
      });
    });
  }

  bindQuantityControls() {
    this.root.querySelectorAll("[data-quantity-step]").forEach(button => {
      button.addEventListener("click", () => {
        const kind = button.dataset.productKind || "";
        const input = this.root.querySelector(`[data-product-quantity="${kind}"]`);
        if (!input) return;

        const step = Number.parseInt(button.dataset.quantityStep || "0", 10);
        const current = Number.parseInt(input.value || "1", 10);
        const next = Math.max(1, current + step);
        input.value = String(next);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    this.root.querySelectorAll("[data-product-quantity]").forEach(input => {
      input.addEventListener("change", () => {
        const value = Number.parseInt(input.value || "1", 10);
        input.value = String(Math.max(1, Number.isFinite(value) ? value : 1));
      });
    });
  }

  findProductListSections() {
    const sections = [];
    const wordFactorySection = this.root.closest(".shopify-section");
    if (!wordFactorySection) return sections;

    let nextSection = wordFactorySection.nextElementSibling;
    while (nextSection) {
      if (nextSection.querySelector('[data-testid="product-list"]')) sections.push(nextSection);
      nextSection = nextSection.nextElementSibling;
    }

    return sections;
  }

  findMugSection() {
    return document.querySelector("[data-nwf-mug-section]") ||
      document.querySelector("#nwf-mug-section") ||
      document.querySelector(".tib-product-form")?.closest(".shopify-section");
  }

  hideProductListSections() {
    this.findProductListSections().forEach(section => {
      section.style.display = "none";
    });
  }

  hideMugPurchaseStep() {
    this.root.classList.remove("nwf-word-placed");
    if (this.elements?.purchaseStep) this.elements.purchaseStep.hidden = true;
    if (this.elements?.mugSection) this.elements.mugSection.hidden = true;
    this.hideProductListSections();
  }

  showMugPurchaseStep() {
    this.root.classList.add("nwf-word-placed");
    document.body.classList.add("nwf-mug-flow");
    this.hideProductListSections();

    if (this.elements.purchaseStep) this.elements.purchaseStep.hidden = false;

    this.elements.mugSection = this.findMugSection();
    if (this.elements.mugSection) {
      this.elements.mugSection.hidden = false;
      this.elements.mugSection.scrollIntoView({ behavior: "smooth", block: "start" });
    } else if (this.elements.purchaseStep) {
      this.elements.purchaseStep.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  setStatus(text, loading = false) {
    if (this.elements.statusText) this.elements.statusText.textContent = text || "";
    this.root.classList.toggle("word-factory--loading", loading);
  }

  getPayload() {
    return {
      who: (this.elements.who?.value || "").trim(),
      what: (this.elements.what?.value || "").trim(),
      vibe: (this.elements.vibe?.value || "").trim()
    };
  }

  parseResult(result) {
    const item = result?.output?.forged?.[0] || result?.forged?.[0] || result || {};
    const word = String(item.word || item.newWord || item.new_word || "").trim();
    const description = this.formatDescription(item.description || item.definition || item.meaning);
    const sampleSentence = String(
      item.sampleSentence || item.sample_sentence || item.example || item.sentence || ""
    ).trim();
    const pronunciation = String(
      item.pronunciation || item.pronunciationKey || item.pronunciation_key || item.phonetic || ""
    ).trim() || this.buildPronunciation(word);

    return { word, pronunciation, description, sampleSentence };
  }

  buildPronunciation(word) {
    const clean = String(word || "")
      .replace(/[^a-z]/gi, "")
      .toLowerCase();

    if (!clean) return "";

    const chunks = clean.match(/[^aeiouy]*[aeiouy]+[^aeiouy]*/gi) || [clean];
    return `/${chunks.join("-")}/`;
  }

  formatDescription(value) {
    const text = String(value || "")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/^\*?adjective\*?\.\s*/i, "")
      .replace(/^adj\.\s*/i, "")
      .replace(/^\*?verb\*?\.\s*/i, "")
      .replace(/^v\.\s*/i, "");

    return text ? `Adjective. ${text}` : "";
  }

  storeProductChoice(kind) {
    const product = NWF_PRODUCT_OPTIONS.find(option => option.kind === kind);

    try {
      localStorage.setItem("nwf_selected_product", product?.kind || kind || "");
      sessionStorage.setItem("nwf_selected_product", product?.kind || kind || "");
      localStorage.setItem("nwf_checkout_after_add", "1");
    } catch (err) {
      console.warn("Unable to save selected Nerd Word product.", err);
    }
  }

  saveGeneratedWord(inputs, generated) {
    const stored = {
      ...inputs,
      ...generated,
      newWord: generated.word,
      pronunciation: generated.pronunciation,
      definition: generated.description,
      example: generated.sampleSentence,
      momentKind: inputs.vibe
    };

    this.lastGenerated = stored;

    try {
      localStorage.setItem("nwf_word", generated.word);
      localStorage.setItem("nwf_description", generated.description || "");
      localStorage.setItem("nwf_definition", generated.description || "");
      localStorage.setItem("nwf_pronunciation", generated.pronunciation || "");
      localStorage.setItem("nwf_sample_sentence", generated.sampleSentence || "");
      localStorage.setItem("nwf_example", generated.sampleSentence || "");
      localStorage.setItem("nwf_meta", JSON.stringify(inputs));
      localStorage.setItem("nwf_generated", JSON.stringify(stored));
      localStorage.removeItem("nwf_origin");

      sessionStorage.setItem("nwf_generated", JSON.stringify(stored));
      sessionStorage.setItem("nwf_pronunciation", generated.pronunciation || "");
      sessionStorage.removeItem("nwf_origin");
    } catch (err) {
      console.warn("Unable to save generated Nerd Word data.", err);
    }

    window.dispatchEvent(new CustomEvent("nwf:wordGenerated", { detail: stored }));
  }

  clearGeneratedWord() {
    [
      "nwf_word",
      "nwf_pronunciation",
      "nwf_description",
      "nwf_definition",
      "nwf_origin",
      "nwf_sample_sentence",
      "nwf_example",
      "nwf_meta",
      "nwf_generated",
      "nwf_place_word",
      "nwf_checkout_after_add"
    ].forEach(key => {
      try {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      } catch (err) {
        console.warn("Unable to clear Nerd Word data.", err);
      }
    });
  }

  renderResult(generated) {
    if (this.elements.word) this.elements.word.textContent = generated.word;

    if (this.elements.pronunciation) {
      this.elements.pronunciation.textContent = generated.pronunciation || this.buildPronunciation(generated.word);
    }

    if (this.elements.description) this.elements.description.textContent = generated.description || "";
    if (this.elements.sampleSentence) this.elements.sampleSentence.textContent = generated.sampleSentence || "";
    this.renderProductPreviews(generated);

    if (!this.elements.resultWrap) return;

    this.elements.resultWrap.hidden = false;
    this.elements.resultWrap.classList.remove("wf-result--show");
    this.elements.resultWrap.offsetWidth;
    this.elements.resultWrap.classList.add("wf-result--show");

    requestAnimationFrame(() => {
      this.elements.resultWrap.scrollIntoView({ behavior: "smooth", block: "nearest" });
      });
  }

  previewWordSize(word) {
    const length = String(word || "").length;
    if (length >= 20) return "0.62rem";
    if (length >= 16) return "0.72rem";
    if (length >= 12) return "0.84rem";
    if (length >= 10) return "0.96rem";
    return "1.15rem";
  }

  renderProductPreviews(generated) {
    const word = generated.word || "-";
    const pronunciation = generated.pronunciation || this.buildPronunciation(word);
    const definition = generated.description || "";
    const sampleSentence = generated.sampleSentence || "";
    const wordSize = this.previewWordSize(word);

    this.root.querySelectorAll("[data-preview-word]").forEach(element => {
      element.textContent = word;
      element.style.setProperty("--wf-preview-word-size", wordSize);
    });

    this.root.querySelectorAll("[data-preview-definition]").forEach(element => {
      element.textContent = definition || "-";
    });

    this.root.querySelectorAll("[data-preview-pronunciation]").forEach(element => {
      element.textContent = pronunciation || "-";
    });

    this.root.querySelectorAll("[data-preview-sample]").forEach(element => {
      element.textContent = sampleSentence || "-";
    });
  }

  getCheckoutItems() {
    const data = this.lastGenerated || {};

    return NWF_PRODUCT_OPTIONS.map(product => {
      const input = this.root.querySelector(`[data-product-quantity="${product.kind}"]`);
      const rawQuantity = Number.parseInt(input?.value || "1", 10);
      const quantity = Math.max(1, Number.isFinite(rawQuantity) ? rawQuantity : 1);
      if (input) input.value = String(quantity);

      return {
        id: product.variantId,
        quantity,
        properties: {
          "New word": data.word || "",
          "Pronunciation key": data.pronunciation || this.buildPronunciation(data.word),
          Definition: data.description || "",
          "Sample sentence": data.sampleSentence || "",
          _nwf_product: product.kind,
          _nwf_recipient: data.who || "",
          _nwf_moment: data.what || "",
          _nwf_moment_kind: data.vibe || ""
        }
      };
    });
  }

  setCheckoutStatus(text, loading = false) {
    if (this.elements.checkoutStatus) this.elements.checkoutStatus.textContent = text || "";
    if (this.elements.btnCheckout) this.elements.btnCheckout.disabled = loading;
  }

  async checkout() {
    if (!this.lastGenerated?.word) {
      this.setCheckoutStatus("Make your word first.");
      return;
    }

    this.setCheckoutStatus("Opening checkout...", true);

    try {
      await fetch("/cart/clear.js", { method: "POST" });

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          items: this.getCheckoutItems()
        })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || "Shopify could not add the products.");
      }

      window.location.assign("/checkout");
    } catch (err) {
      console.error("Nerd Word checkout error:", err);
      this.setCheckoutStatus("Checkout did not open. Please try again.", false);
    }
  }

  async generate() {
    const inputs = this.getPayload();

    if (!inputs.who || !inputs.what || !inputs.vibe) {
      this.setStatus("Please fill in who, the moment, and what kind of moment this is.", false);
      return;
    }

    this.elements.btnGenerate.disabled = true;
    this.setStatus("Making your word...", true);
    this.hideMugPurchaseStep();

    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 25000);

    try {
      const response = await fetch(this.endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(inputs),
        signal: controller.signal
      });

      if (!response.ok) {
        const errorText = await response.text().catch(() => "");
        throw new Error(errorText || `Request failed: ${response.status}`);
      }

      const generated = this.parseResult(await response.json().catch(() => ({})));
      if (!generated.word) throw new Error("No word returned from API.");

      this.saveGeneratedWord(inputs, generated);
      this.renderResult(generated);
      this.setStatus("Your word is ready.", false);
    } catch (err) {
      console.error("Word Factory error:", err);
      const message = err.name === "AbortError"
        ? "The word maker took too long. Please try again."
        : "Error generating your word. Please try again.";
      this.setStatus(message, false);
    } finally {
      window.clearTimeout(timeout);
      this.elements.btnGenerate.disabled = false;
    }
  }

  placeWord() {
    if (!this.lastGenerated) {
      this.setStatus("Make your word first.", false);
      return;
    }

    try {
      localStorage.setItem("nwf_place_word", "1");
      sessionStorage.setItem("nwf_place_word", "1");
      localStorage.setItem("nwf_checkout_after_add", "1");
    } catch (err) {
      console.warn("Unable to mark Nerd Word as placed.", err);
    }

    window.dispatchEvent(new CustomEvent("nwf:placeWord", { detail: this.lastGenerated }));
    this.showMugPurchaseStep();
    this.setStatus("Opening your mug preview...", false);
    window.location.assign(NWF_MUG_PRODUCT_URL);
  }

  reset() {
    if (this.elements.who) this.elements.who.value = "";
    if (this.elements.what) this.elements.what.value = "";
    if (this.elements.vibe) this.elements.vibe.value = "";
    this.lastGenerated = null;
    this.setStatus("", false);

    if (this.elements.resultWrap) {
      this.elements.resultWrap.hidden = true;
      this.elements.resultWrap.classList.remove("wf-result--show");
    }

    this.clearGeneratedWord();
    this.hideMugPurchaseStep();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  observeNwfProductName();

  document.querySelectorAll('[id^="word-factory-"]').forEach(root => {
    new WordFactory(root);
  });
});
